/* The transformation card of the card library, also dealt by the character builder. */

import { CSSProperties } from 'react';
import type { Transformation } from '../content/transformations';
import { sourceLabel } from '../content/sources';
import { parseTextWithTerms } from '../content/parseText';
import heritageArt from './heritage-art.svg';
import './cards.css';

const DOMAIN_COLOR = '#9b5fdd';

export function TransformationCard({ t }: { t: Transformation }) {
  return (
    <div
      className="portrait-card"
      style={{ '--domain-color': DOMAIN_COLOR } as CSSProperties}
    >
      <div className="card-sheet__bg" aria-hidden="true">
        <img src={heritageArt} className="card-sheet__icon" alt="" />
      </div>
      <div className="card-sheet__type">Transformation</div>
      <h2 className="card-sheet__name">{t.name}</h2>
      <div className="card-sheet__rule" aria-hidden="true" />
      <div className="card-sheet__body">
        <p className="tf-subtitle">{t.subtitle}</p>
        <p className="tf-feature-text">
          <strong className="tf-feature-benefit">{t.benefit.name}:</strong>{' '}
          {parseTextWithTerms(t.benefit.text)}
        </p>
        <p className="tf-feature-text">
          <strong className="tf-feature-drawback">{t.drawback.name}:</strong>{' '}
          {parseTextWithTerms(t.drawback.text)}
        </p>
      </div>

      {/* Footer */}
      <div className="card-sheet__footer">
        <span>{sourceLabel(t.source)}</span>
        <span className="card-sheet__footer-dot">·</span>
        <span>dhtools.net</span>
      </div>
    </div>
  );
}
